<app-page-header
  title="Usuários"
  subtitle="Gerencie os usuários do sistema, atribua grupos e ative ou desative contas."
  [showAction]="true"
  actionLabel="Novo Usuário"
  (action)="openCreate()"
/>

<app-grid-toolbar
  [toolbarFilters]="toolbarFilters"
  (filtersChange)="onFiltersChange($event)"
  (exportClick)="onExport($event)"
/>

<app-data-grid
  path="users"
  [columns]="columns"
  [filters]="gridFilters"
  editRoutePrefix=""
  emptyMessage="Nenhum usuário encontrado."
  (editRow)="openEdit($event)"
  (deleteRow)="confirmAction($event, 'deactivate')"
/>

<!-- ── Modal Criar / Editar ────────────────────────────── -->
@if (modalMode) {
  <div class="modal-backdrop" (click)="closeModal()"></div>
  <div class="modal">
    <div class="modal__header">
      <h2 class="modal__title">
        {{ modalMode === 'create' ? 'Novo Usuário' : 'Editar Usuário' }}
      </h2>
      <button class="modal__close" (click)="closeModal()"><i class="bi bi-x-lg"></i></button>
    </div>

    @if (modalError) {
      <div class="alert alert--error modal__alert">
        <i class="bi bi-exclamation-circle"></i> {{ modalError }}
      </div>
    }

    <div class="modal__body">
      @if (modalMode === 'create') {
        <div class="form-group">
          <label class="form-label">Nome <span class="required">*</span></label>
          <input type="text" class="form-control" [(ngModel)]="createForm.name" placeholder="Nome completo" />
        </div>
        <div class="form-group">
          <label class="form-label">E-mail <span class="required">*</span></label>
          <input type="email" class="form-control" [(ngModel)]="createForm.email" placeholder="email@exemplo.com" />
        </div>
        <div class="form-group">
          <label class="form-label">Senha temporária <span class="required">*</span></label>
          <input type="password" class="form-control" [(ngModel)]="createForm.password" placeholder="Senha inicial" />
        </div>
      }

      @if (modalMode === 'edit') {
        <div class="form-group">
          <label class="form-label">Nome</label>
          <input type="text" class="form-control" [(ngModel)]="editForm.name" placeholder="Nome completo" />
        </div>
        <div class="form-group">
          <label class="form-label">Grupos</label>
          <div class="groups-list">
            @if (groups.length === 0) {
              <p class="groups-list__empty">Nenhum grupo cadastrado.</p>
            }
            @for (group of groups; track group.id) {
              <label class="group-checkbox">
                <input type="checkbox" [checked]="isGroupSelected(group.id)" (change)="toggleGroup(group.id)" />
                <span class="group-checkbox__label">{{ group.name }}</span>
              </label>
            }
          </div>
        </div>
      }
    </div>

    <div class="modal__footer">
      <button class="btn btn--ghost" (click)="closeModal()" [disabled]="saving">Cancelar</button>
      <button class="btn btn--primary" (click)="modalMode === 'create' ? submitCreate() : submitEdit()" [disabled]="saving">
        @if (saving) { <span class="spinner spinner--sm"></span> } @else { <i class="bi bi-check-lg"></i> }
        {{ saving ? 'Salvando…' : 'Salvar' }}
      </button>
    </div>
  </div>
}

<!-- ── Confirmação ─────────────────────────────────────── -->
<app-confirm-dialog
  [message]="confirmMessage"
  [visible]="!!actionTarget"
  (confirmed)="executeAction()"
  (cancelled)="cancelAction()"
/>
